import { createFileRoute } from "@tanstack/react-router";
import { AccommodationDetailPage } from "../../components/participant/accommodation-detail-page";

/** `/me/accommodation/:roomAssignmentId` — one of the participant's own stays in full. Not nested under the list (its own page); someone else's stay is 404. */
export const Route = createFileRoute("/_app/me/accommodation_/$roomAssignmentId")({
	component: function StayRoute() {
		const { roomAssignmentId } = Route.useParams();
		return <AccommodationDetailPage roomAssignmentId={roomAssignmentId} />;
	},
});
